import createSelectors from './createSelectors';
import OrganisationMessageTemplate from '../models/OrganisationMessageTemplate';

const Select = createSelectors(OrganisationMessageTemplate, {});

export default Select;
